module.exports = __webpack_public_path__ + "img/detail-logo@3x.a7a5b39d.png";